var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgToolCapture = ({
  title,
  titleId,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 28,
  height: 28,
  viewBox: "0 0 28 28",
  xmlns: "http://www.w3.org/2000/svg",
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("path", {
  d: "M0 0h28v28H0z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M8.644 8.556a1.901 1.901 0 0 0 1.109-.432l1.853-1.692c.314-.26.702-.41 1.109-.432h2.903c.403.023.788.175 1.099.432l1.853 1.692c.314.259.702.41 1.109.432h3.427a2.135 2.135 0 0 1 1.917 2.149v8.712a1.917 1.917 0 0 1-1.917 1.916H5.216A1.917 1.917 0 0 1 3.3 19.417v-8.712a2.135 2.135 0 0 1 1.917-2.15h3.427Z",
  stroke: "currentColor",
  strokeWidth: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("circle", {
  stroke: "currentColor",
  strokeWidth: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round",
  cx: 14.161,
  cy: 13.986,
  r: 3.514
}), /*#__PURE__*/React.createElement("path", {
  d: "M21.828 11.43a.32.32 0 1 1 0 .64.32.32 0 0 1 0-.64",
  stroke: "currentColor",
  strokeWidth: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}))));
export { SvgToolCapture as ReactComponent };
export default __webpack_public_path__ + "assets/images/tool-capture.svg";